<template>
  <div id="trajectory-diagram" />
</template>

<script>
import'../../../assets/js/china.js'
import chartData from '../js/TrajectoryDiagramData'
export default {
  props: {
    trajectory: Array
  },

  data () {
    return {
      option: chartData.option,
      timer: null,
      chart: null,
      showTimer: null
    }
  },

  watch: {
    trajectory () {
      const data = []
      const data2 = []
      this.trajectory.forEach(element => {
        const dataItem = [
          {
            coord: element.name,
            value: element.title,
          },
          {
            coord: element.value,
          }
        ]
        data.push(dataItem)
        data2.push({value: element.name})
        data2.push({value: element.value})
      })
      this.option.series[0].data = data
      this.option.series[1].data = data2
      console.log(data)
      // this.option.series[1].data = this.option.series[1].data.concat(data2)
      this.showTip()
      this.myEcharts()
    }
  },

  mounted () {
    this.myEcharts()
  },

   methods: {
    myEcharts () {
      if (this.chart) {
        this.chart.setOption(this.option)
      } else {
        this.chart = this.$echarts.init(document.getElementById("trajectory-diagram"))
        this.chart.setOption(this.option)
      }
    },

    showTip () {
      var app = {
        currentIndex: -1,
      }
      this.showTimer && clearInterval(this.showTimer)
      this.showTimer = setInterval( () => {
        const dataLen = this.option.series[0].data.length
        app.currentIndex = (app.currentIndex + 1) % dataLen
        this.chart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: app.currentIndex
        })
        setTimeout(() => {
          this.chart.dispatchAction({
            type: 'hideTip',
            seriesIndex: 0,
            dataIndex: app.currentIndex
          });
        }, 1000 * 2)
      }, 1000 * 10)
    }
  }
}
</script>

<style>
#trajectory-diagram {
  width: 648px;
  height: 393px;
}
</style>